import { CommonModule, formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { AuthService } from '../../Service/app-service';
import { SearchPipe } from '../../search-pipe.pipe';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    NgxIntlTelInputModule,
    SearchPipe,
    NgxSpinnerModule,
    NgMultiSelectDropDownModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {
  showDetails: boolean = false;
  showLogs: boolean = false;
  showsmsLogs: boolean = false;
  userInfo = {
    number: '263779012735',
    userStatus: 'Active',
    activePlan: 'Monthly',
    registrationPlan: '2021-09-08 14:38:39',
    subscriptionDate: '2021-09-08 14:38:39',
    renewalDate: '2021-09-08 14:38:39',
    lastChargedDate: '',
    deactiveDate: '',
  };
  transactions = [];
  sms = [];
  searchQuery: string = '';
  searchQuerysms: string = '';
  filteredTransactions: any[] = [];
  filteredsms: any[] = [];
  paginatedTransactions: any[] = [];
  paginatedsms: any[] = [];
  currentPage: number = 1;
  currentPage1: number = 1;
  rowsPerPage: number = 5;
  rowsPerPage1: number = 5;
  totalPages: number = 1;
  totalPages1: number = 1;
  pageSizes: number[] = [5, 10, 20];
  dropdownSettings = {};
  toBeEditedTagId: any;
  genreArray: any;
  statusChangeText: any;
  openConfirmChnagePopup: boolean = false;
  showContentConfiguration: boolean = false;
  Generes: boolean = false;
  genreForm: any;
  userName: string | null = '';
  userid: any;
  useremail: string = '';
  phoneNumber: string = '';
  currentsubscription: any;
  errorMessage!: string;
  errorMessagetransaction: string | null = null;
  email: string = '';
  selectedphoneId: any;
  passwordErrorMessage: string = '';
  successMessage: string = '';
  subscriptionId: any;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  sortColumnsms: string = '';
  sortDirectionsms: string = '';
  showOldPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  changePasswordForm!: FormGroup;
  constructor(private modalService: NgbModal, private router: Router,private tosterService: ToastrService, private SpinnerService: NgxSpinnerService, private authService: AuthService, private fb: FormBuilder) {
  }
  showTransactionLogs(): void {
    this.showLogs = !this.showLogs;
    this.loadTransactionLogs();
    if (this.showLogs && this.transactions.length === 0) {
      this.loadTransactionLogs();
    }
  }
  showSMSLogs(): void {
    this.showsmsLogs = !this.showsmsLogs;
    this.getSmsLogs();
  }
  togglePassword(field: string) {
    if (field === 'old') {
      this.showOldPassword = !this.showOldPassword;
    } else if (field === 'new') {
      this.showNewPassword = !this.showNewPassword;
    } else if (field === 'confirm') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  getImageUrl(): string {
    return environment.iamge
   }
  customer(){
    window.location.reload();
  }
  getDetails() {
    if (this.phoneNumber.trim()) {
      this.authService.getPhoneDetails(this.phoneNumber).subscribe(
        (response: any) => {
          
          if (response && response.statusCode === 200) {
            this.showDetails = true;
             this.currentsubscription = response.data;
             this.subscriptionId = this.currentsubscription.id;
             this.errorMessage= '';
          } else {
            this.errorMessage = 'Failed to fetch details. Please try again.';
            this.showDetails = false;
          }
        },
        (error) => {
          // Handle error here
          this.errorMessage = error.error?.message || 'An error occurred. Please try again later.';
          this.showDetails = false;
        }
      );
    } else {
      this.errorMessage = 'Phone number is required';
      this.showDetails = false;
    }
    this.showLogs = false;  //changes by Naved
    this.showsmsLogs = false ; //changes by Naved
  }

  openAddForm(content: any) {
    this.toBeEditedTagId = null
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }
  openAddDeactivateForm(content: any,  phoneid: number) {
    this.selectedphoneId = phoneid;
    this.toBeEditedTagId = null
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }
  onCancel() {
    this.modalService.dismissAll();
  }
  ngOnInit(): void {
    this.filteredTransactions = [...this.transactions];
    this.filteredsms = [...this.sms];
    this.updatePagination();
    this.updatePaginationsms();
    this.userName = this.authService.getUserName() || 'Guest';
    this.userid = this.authService.getUserid();
    this.useremail = this.authService.getUseremail() || '';
    this.changePasswordForm = this.fb.group({
      oldPassword: ['', Validators.required, ],
      newPassword: ['', [
        Validators.required,
        Validators.pattern('(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}'),
        this.differentFromOldPasswordValidator('oldPassword')
      ]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.mustMatch('newPassword', 'confirmPassword') });
  }
  get oldPassword() {
    return this.changePasswordForm.get('oldPassword');
  }
  get newPassword() {
    return this.changePasswordForm.get('newPassword');
  }

  get confirmPassword() {
    return this.changePasswordForm.get('confirmPassword');
  }

  preventSpace(event: KeyboardEvent): void {
    if (event.code === 'Space' || event.key === ' ') {
      event.preventDefault();
    }
  }
  differentFromOldPasswordValidator(oldPasswordControlName: string) {
    return (control: any) => {
      const formGroup = control?.parent;
      if (!formGroup) {
        return null;
      }

      const oldPassword = formGroup.get(oldPasswordControlName)?.value;
      const newPassword = control.value;

      if (oldPassword && newPassword === oldPassword) {
        return { sameAsOldPassword: true }; // Custom error
      }

      return null;
    };
  }
  // Custom validator to check if newPassword and confirmPassword match
  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.get(controlName);
      const matchingControl = formGroup.get(matchingControlName);

      if (matchingControl?.errors && !matchingControl.errors['mustMatch']) {
        return;
      }

      if (control?.value !== matchingControl?.value) {
        matchingControl?.setErrors({ mustMatch: true });
      } else {
        matchingControl?.setErrors(null);
      }
    };
  }
  Deactivateuser(selectedphoneId: string): void {
    this.authService.Deactivateuser(selectedphoneId).subscribe(
      (response: any) => {
        this.getDetails()
        this.modalService.dismissAll();
      },
      (error: HttpErrorResponse) => {
        console.error('Error occurred:', error);
        console.error('Error Details:', error.message);
        console.error('Error Body:', error.error);
      }
    );
  }
  loadTransactionLogs(): void {
    this.errorMessagetransaction = null;
    this.transactions = []
    this.paginatedTransactions = []
    this.authService.getTransactionLogs(this.subscriptionId).subscribe(
      (response) => {
        if (response.data && response.data.length > 0) {
          this.transactions = response.data;
          this.filteredTransactions = [...this.transactions];
          this.errorMessagetransaction = null; 
          this.updatePagination();
        } else {
          this.transactions = [];
          this.filteredTransactions = [];
          this.errorMessagetransaction = 'Transactions logs not exist';
        }
      },
      (error) => {
        this.transactions = [];
        this.filteredTransactions = [];
        if (error.status === 404) {
          this.errorMessagetransaction = 'Transactions logs not exist';
        } else {
          this.errorMessagetransaction = error.error?.message || 'An error occurred. Please try again later.';
        }
      }
    );
  }
  onCancelchange(): void {
    this.changePasswordForm.reset();
    this.modalService.dismissAll(); 
  }
  getStartIndex(): number {
    return (this.currentPage - 1) * this.rowsPerPage + 1;
  }
  getEndIndex(): number {
    const endIndex = this.currentPage * this.rowsPerPage;
    return endIndex > this.filteredTransactions.length ? this.filteredTransactions.length : endIndex;
  }
  filterTransactions(): void {
    let query = this.searchQuery.toLowerCase();
    if (query.startsWith(' ') && query.length > 0) {
      query = query.trimStart();
    }
  
    this.filteredTransactions = this.transactions.filter((transaction) => {
      return Object.entries(transaction).some(([key, value]: [string, any]) => {
        if (key === 'date' && value) {
          const formattedDate = formatDate(value, 'dd-MM-yyyy, hh:mm a', 'en-US');
          return formattedDate.toLowerCase().includes(query);
        }
        return value ? value.toString().toLowerCase().includes(query) : false;
      });
    });
  
    this.currentPage = 1;
    this.updatePagination();
  }
  updatePagination(): void {
    this.totalPages = Math.ceil(this.filteredTransactions.length / this.rowsPerPage) || 1;
    this.currentPage = Math.min(this.currentPage, this.totalPages);
    const startIndex = (this.currentPage - 1) * this.rowsPerPage;
    const endIndex = this.currentPage * this.rowsPerPage;
    this.paginatedTransactions = this.filteredTransactions.slice(startIndex, endIndex);
  }

  changePage(page: any): void {
    if (typeof page !== 'number') return;
    this.currentPage = page;
    this.updatePagination();
  }

  getPages(): (number | string)[] {
    const pages: (number | string)[] = [];
    const maxPagesToShow = 5;

    if (this.totalPages <= maxPagesToShow) {
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

      if (this.currentPage <= halfMaxPagesToShow + 1) {
        for (let i = 1; i <= maxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages);
      } else if (this.currentPage >= this.totalPages - halfMaxPagesToShow) {
        pages.push(1);
        pages.push('...');
        for (let i = this.totalPages - (maxPagesToShow - 2); i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = this.currentPage - halfMaxPagesToShow + 1; i <= this.currentPage + halfMaxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages);
      }
    }

    return pages;
  }

  isValidPage(page: number | string): page is number {
    return typeof page === 'number';
  }
  sortTable(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.filteredTransactions.sort((a: any, b: any) => {
      const valueA = a[column] || '';
      const valueB = b[column] || '';

      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    this.updatePagination();
  }
  getSortIcon(column: string): string {
    if (this.sortColumn === column) {
      return this.sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down';
    }
    return '';
  }
  getSmsLogs(): void {
    if (this.currentsubscription && this.currentsubscription.phone) {
      const phoneNumber = this.currentsubscription.phone;
      this.sms = []
      this.paginatedsms = []
      this.authService.getsmslogs(phoneNumber).subscribe(
        (response) => {
          this.sms = response.data || [];
          
          this.filteredsms = [...this.sms];
          
          this.updatePaginationsms();
        },
        (error) => {
          if (error.status === 404) {
            this.sms = [];
            this.filteredsms = [];
            this.errorMessage = 'SMS logs not exist';
          } else {
            this.errorMessage = error.error?.message || 'An error occurred. Please try again later.';
          }
        }
      );
    }
  }
  getStartIndexsms(): number {
    return (this.currentPage1 - 1) * this.rowsPerPage1 + 1;
  }
  getEndIndexsms(): number {
    const endIndex = this.currentPage1 * this.rowsPerPage1;
    return endIndex > this.filteredsms.length ? this.filteredsms.length : endIndex;
  }
  filtersms(): void {
    let query = this.searchQuerysms.toLowerCase();
    if (query.startsWith(' ') && query.length > 0) {
      query = query.trimStart();
    }
    this.filteredsms = this.sms.filter((sms) =>
      {
        return Object.entries(sms).some(([key, value]: [string, any]) => {
          if (key === 'date' && value) {
            const formattedDate = formatDate(value, 'dd-MM-yyyy, hh:mm a', 'en-US');
            return formattedDate.toLowerCase().includes(query);
          }
          return value ? value.toString().toLowerCase().includes(query) : false;
        });
      });
    this.currentPage1 = 1;
    this.updatePaginationsms();
  }
  updatePaginationsms(): void {
    this.totalPages1 = Math.ceil(this.filteredsms.length / this.rowsPerPage1) || 1;
    this.currentPage1 = Math.min(this.currentPage1, this.totalPages1);
    const startIndex = (this.currentPage1 - 1) * this.rowsPerPage1;
    const endIndex = this.currentPage1 * this.rowsPerPage1;
    this.paginatedsms = this.filteredsms.slice(startIndex, endIndex);
  }

  changePage1(page: any): void {
    if (typeof page !== 'number') return;
    this.currentPage1 = page;
    this.updatePaginationsms();
  }

  getPagessms(): (number | string)[] {
    const pages: (number | string)[] = [];
    const maxPagesToShow = 5;

    if (this.totalPages1 <= maxPagesToShow) {
      for (let i = 1; i <= this.totalPages1; i++) {
        pages.push(i);
      }
    } else {
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

      if (this.currentPage1 <= halfMaxPagesToShow + 1) {
        for (let i = 1; i <= maxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages1);
      } else if (this.currentPage1 >= this.totalPages1 - halfMaxPagesToShow) {
        pages.push(1);
        pages.push('...');
        for (let i = this.totalPages1 - (maxPagesToShow - 2); i <= this.totalPages1; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = this.currentPage1 - halfMaxPagesToShow + 1; i <= this.currentPage1 + halfMaxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages1);
      }
    }

    return pages;
  }
 
  sortsms(column: string): void {
    if (this.sortColumnsms === column) {
      this.sortDirectionsms = this.sortDirectionsms === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnsms = column;
      this.sortDirectionsms = 'asc';
    }

    this.filteredsms.sort((a: any, b: any) => {
      const valA = a[column] || '';
      const valB = b[column] || '';

      if (this.sortDirectionsms === 'asc') {
        return valA > valB ? 1 : valA < valB ? -1 : 0;
      } else {
        return valA < valB ? 1 : valA > valB ? -1 : 0;
      }
    });

    this.updatePaginationsms();
  }
  openGeneres() {
    this.Generes = !this.Generes;
    this.showContentConfiguration = false;
  }

  onSubmit(): void {
    this.SpinnerService.show();
    // Check if the form is valid
    if (this.changePasswordForm.valid) {
      // Extract form values
      const { oldPassword, newPassword, confirmPassword } = this.changePasswordForm.value;
  
      // Create request body
      const requestBody = {
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmPassword: confirmPassword
      };
      // Stagging@12345
      // Call the changePassword service
      this.email = this.useremail;
      this.authService.changePassword(this.email, requestBody).subscribe({
        next: (response) => {
          console.log('Password change response:', response);
          this.successMessage = 'Password changed successfully!';
          setTimeout(() => {
            this.clearAuthToken();
            this.SpinnerService.hide();
            this.tosterService.success(this.successMessage);
            this.router.navigate(['/login']);
            this.modalService.dismissAll();
          }, 3000);
        },
        error: (error) => {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.tosterService.error(error.error.data);
          console.error('Error changing password:', error);
          this.passwordErrorMessage = 'Current password is incorrect';
        },
      });
    } else {
      this.SpinnerService.hide();
      this.changePasswordForm.markAllAsTouched();
      console.error('Form is invalid. Please check the inputs.');
    }
  }
  clearAuthToken(): void {
    sessionStorage.removeItem('token');
  }
  logout(): void {
    this.SpinnerService.show();
    const token = sessionStorage.getItem('token');

    if (!token) {
      this.SpinnerService.hide();
      this.tosterService.error('No token found. Please log in again.');
      // alert('No token found. Please log in again.');
      return;
    }

    this.authService.logout(token).subscribe({
      next: (response) => {
        console.log('Logout successful:', response);
        sessionStorage.removeItem('token');
        // this.showToast();
        setTimeout(() => {
          this.tosterService.success('Logout successfully');
          this.SpinnerService.hide();
          this.router.navigate(['/login']);
        }, 2000);
      
        
      },
      error: (error) => {
        this.tosterService.error(error.error.message);
        console.error('Error during logout:', error);
        this.SpinnerService.hide();
        // alert('An error occurred while logging out.');
      },
    });
    this.modalService.dismissAll();
  }
  // showToast(): void {
  //   const toast = document.getElementById('customToast');
  //   if (toast) {
  //     toast.classList.add('show');
  //     setTimeout(() => {
  //       toast.classList.remove('show');
  //     }, 2000);
  //   }
  // }
  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
}